import { WarnMessage } from "@/components/Message";
import { useRouteAndTeamInfo } from "@/utils/hooks/url/use-route-info";
import { Routes } from "@/utils/routes";
import { ChalkLink } from "@/components/interactive/ChalkLink";
import { isAdminSuspended } from "@/utils/environment";
import React from "react";

export interface SuspendedEnvironmentWarningProps {}

export const SuspendedEnvironmentWarning: React.FC<SuspendedEnvironmentWarningProps> = ({}) => {
  const { environment, environmentId, projectId } = useRouteAndTeamInfo();
  const adminSuspended = isAdminSuspended(environment);

  return environment != null &&
    environment.suspendedAt != null &&
    environmentId != null &&
    projectId != null ? (
    <WarnMessage title={adminSuspended ? "Suspended by Chalk" : "Environment Suspended"} compact>
      {adminSuspended ? (
        <>
          This environment was suspended by Chalk and is unavailable for querying. Contact support
          to resume it.
        </>
      ) : (
        <>
          This environment is suspended, so it will not consume resources or be available for
          querying. This includes the in-cluster database (metrics), which means that some dashboard
          components may be missing data or may fail to load.{" "}
          <ChalkLink
            className={"link"}
            href={Routes.project.environment.settings(projectId, environmentId, "suspend")}
          >
            View suspension settings.
          </ChalkLink>
        </>
      )}
    </WarnMessage>
  ) : null;
};

export interface SimpleSuspendedWarningProps {
  featureName?: string;
}

export const SimpleSuspendedWarning: React.FC<SimpleSuspendedWarningProps> = ({ featureName }) => {
  return (
    <WarnMessage title={"Environment Suspended"}>
      {featureName ?? "This feature is"} unavailable; environment is suspended
    </WarnMessage>
  );
};
